
<!-- Alerts is the page which holds all the alerts which users will be interested in -->
<template>
  <v-container class="py-5 px-5" fluid v-if="this.$store.state.signedIn">
    <v-layout wrap>
        <v-flex xs12 xl6 name="asnlist" class="px-4">
            <OldRules></OldRules>
            <v-layout>
                <userorgrules :type="org_user" />
            </v-layout>
            <v-layout>
                <asnrules :type="org_user" />
            </v-layout>
            <br />
            <asnlist type="alert" :parentData="myData" v-on:passChildASN="getOrgNotifs" v-if="org_user=='org'" ></asnlist>
            <br v-if="org_user=='org'"/>
            <asnlistuser type="alert" :parentData="myData" v-on:passChildASN="getUserNotifs" v-if="org_user=='user'"></asnlistuser>
            <br v-if="org_user=='user'"/>

            <v-layout wrap justify-center v-if="org_user=='org'">
                <v-flex xs12>
                    <v-card>
                        <v-toolbar dark flat color="secondary">
                            <v-toolbar-title :style="$store.state.textFormatting.headers"> {{ organisation }} Alert summaries by Restricted prefix
                                <v-tooltip top color="secondary">
                                    <template v-slot:activator="{ on }">
                                        <small v-on="on" :style="$store.state.textFormatting.main"> (select row to filter alerts) </small>         
                                    </template>
                                    <span :style="$store.state.textFormatting.main">(select row to filter alerts)</span>
                                </v-tooltip>
                            </v-toolbar-title>
                            <v-progress-circular v-if="contLoading" indeterminate color="white"></v-progress-circular>

                            <v-spacer></v-spacer>

                            <v-menu open-on-hover>
                                <template v-slot:activator="{ on }">
                                    <v-btn outline v-on="on"> <v-toolbar-title> <h4 :style="$store.state.textFormatting.main"> {{ hoursback }} Hours back</h4> </v-toolbar-title> </v-btn>
                                </template>
                                <v-list v-for="i in orderByList2" :key="i.param">
                                    <v-list-tile @click="refreshList(i.param)">
                                        <v-list-tile-title :style="$store.state.textFormatting.main"> {{i.name}} </v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>

                            <v-flex shrink class="px-1">
                                <v-tooltip top eager close-delay=500 >
                                    <template v-slot:activator="{ on }">
                                        <v-toolbar-title v-on="on">
                                            <small>
                                                <small :style="$store.state.textFormatting.main">
                                                    {{ updatedStr }} 
                                                </small>
                                            </small>
                                        </v-toolbar-title>
                                    </template>
                                    <span :style="$store.state.textFormatting.main"> {{ updatedStr }} </span>
                                </v-tooltip>
                            </v-flex>
                            
                            <v-btn @click="showOrgCont=!showOrgCont" class="mx-2" small fab color="blue" dark v-if="!showOrgCont"> <h2> - </h2> </v-btn>
                            <v-btn @click="showOrgCont=!showOrgCont" class="mx-2" small fab color="blue" dark v-if="showOrgCont"> <h2> + </h2> </v-btn>
                
                            <info>
                                <template slot>
                                    View alerts per organisation defined Restricted prefix
                                </template>
                                <template slot="body">
                                    
                                    <p> Shows a summary of alerts by organisation defined Restricted prefix, split out by types </p>
                                    <p> Click any row to see alerts for the given prefix (limited to <b>2000</b> alerts)</p>
                                    
                                    <br />
                                </template>
                            </info>

                        </v-toolbar>    
                        <v-data-table :headers="contPrefixHeaders" :items="orgPrefixes" :key="id"
                        :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination" v-if="!contLoading & !showOrgCont" 
                        >    
                            <template slot="headerCell" slot-scope="props">
                                <v-tooltip top eager>
                                <span slot="activator" :style="$store.state.textFormatting.main">
                                    {{ props.header.text }}
                                </span>
                                <span :style="$store.state.textFormatting.main">
                                    {{ props.header.ad_text }}
                                </span>
                                </v-tooltip>
                            </template>
                            <template slot="items" slot-scope="props">
                                <tr>
                                    <td @click="getOrgNotifs(props.item.ip_address,hoursback)" class="text-xs-left special" :style="$store.state.textFormatting.main"> {{props.item.hostname}} </td>
                                    <td @click="getOrgNotifs(props.item.ip_address,hoursback)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.ip_address }}</td>
                                    <!--
                                    <td class="text-xs-center special" @click="getUserNotifs(props.item.ipv4_address)"> {{ props.item.ipv4_address }}</td>
                                    <td class="text-xs-center special" @click="getUserNotifs(props.item.ipv6_address)"> {{ props.item.ipv6_address }}</td>
                                    !-->
                                    <td @click="getOrgNotifs(props.item.ip_address,hoursback)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.asn }}</td>
                                    <!-- <td class="text-xs-center special"> {{ props.item.description }}</td> !-->
                                    <td class="text-xs-center" :style="$store.state.textFormatting.main">
                                        {{ props.item.notification_count }} 
                                        
                                        <v-icon small color="success" :style="$store.state.textFormatting.main" v-if="!props.item.noti_show && props.item.notification_count > 0" @click="viewNotif(props.item)"> add </v-icon> 
                                    
                                        <v-icon color="success" :style="$store.state.textFormatting.main" v-if="props.item.noti_show && props.item.notification_count > 0" small @click="viewNotif(props.item)"> remove </v-icon> 
                                        
                                        <small v-if="props.item.noti_show">
                                            <br />
                                            {{ props.item.notification_str }}
                                        </small>

                                    </td>
                                    <td @click="getOrgNotifs(props.item.ip_address,hoursback)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{props.item.ownership_assertion_count}} </td>
                                    <td @click="getOrgNotifs(props.item.ip_address,hoursback)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{props.item.path_change_count}} </td>
                                    <td @click="getOrgNotifs(props.item.ip_address,hoursback)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{props.item.first_seen_count}} </td>
                                </tr>
                                
                            </template>
                            <template slot="no-data">
                                <v-alert :value="true" color="success" icon="warning" :style="$store.state.textFormatting.main">
                                No organisation prefixes
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
                <br />
            </v-layout>
            
            <v-layout wrap justify-center v-if="org_user=='user'">
                <v-flex xs12>
                    <v-card>
                        <v-toolbar dark flat color="accent">
                            <v-toolbar-title :style="$store.state.textFormatting.headers"> {{ username }} Alert summaries by Restricted prefix<v-tooltip top color="secondary">
                                    <template v-slot:activator="{ on }">
                                        <small v-on="on" :style="$store.state.textFormatting.main"> (select row to filter alerts) </small>         
                                    </template>
                                    <span :style="$store.state.textFormatting.main">(select row to filter alerts)</span>
                                </v-tooltip>
                            </v-toolbar-title>
                            <v-progress-circular v-if="contLoading" indeterminate color="white"></v-progress-circular>

                            <v-spacer></v-spacer>

                            <v-menu open-on-hover>
                                <template v-slot:activator="{ on }">
                                    <v-btn outline v-on="on"> <v-toolbar-title> <h4 :style="$store.state.textFormatting.main"> {{ hoursback }} Hours back</h4> </v-toolbar-title> </v-btn>
                                </template>
                                <v-list v-for="i in orderByList2" :key="i.param">
                                    <v-list-tile @click="refreshList(i.param)">
                                        <v-list-tile-title :style="$store.state.textFormatting.main"> {{i.name}} </v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>

                            <v-flex shrink class="px-1">
                                <v-tooltip top eager close-delay=500 >
                                    <template v-slot:activator="{ on }">
                                        <v-toolbar-title v-on="on">
                                            <small>
                                                <small :style="$store.state.textFormatting.main">
                                                    {{ updatedStr }} 
                                                </small>
                                            </small>
                                        </v-toolbar-title>
                                    </template>
                                    <span :style="$store.state.textFormatting.main"> {{ updatedStr }} </span>
                                </v-tooltip>
                            </v-flex>

                            <v-btn @click="showUserCont=!showUserCont" class="mx-2" small fab color="blue" dark v-if="!showUserCont"> <h2> - </h2> </v-btn>
                            <v-btn @click="showUserCont=!showUserCont" class="mx-2" small fab color="blue" dark v-if="showUserCont"> <h2> + </h2> </v-btn>
                            <info>
                                <template slot>
                                    View alerts per user defined Restricted prefix
                                </template>
                                <template slot="body">
                                    
                                    <p> Shows a summary of alerts by user defined Restricted prefix, split out by types </p>
                                    <p> Click any row to see alerts for the given prefix (limited to <b>2000</b> alerts)</p>
                                    
                                    
                                    <br>
                                </template>
                            </info>

                        </v-toolbar>    
                        <v-data-table :headers="contPrefixHeaders" :items="userPrefixes" :key="id"
                        :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination" v-if="!contLoading & !showUserCont"
                        >    
                            <template slot="headerCell" slot-scope="props">
                                <v-tooltip top eager>
                                <span slot="activator" :style="$store.state.textFormatting.main">
                                    {{ props.header.text }}
                                </span>
                                <span :style="$store.state.textFormatting.main">
                                    {{ props.header.ad_text }}
                                </span>
                                </v-tooltip>
                            </template>
                            <template slot="items" slot-scope="props">
                                <tr>
                                    <td @click="getUserNotifs(props.item.ip_address,hoursback)" class="text-xs-left special" :style="$store.state.textFormatting.main"> {{props.item.hostname}} </td>
                                    <td @click="getUserNotifs(props.item.ip_address,hoursback)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.ip_address }}</td>
                                    <!--
                                    <td class="text-xs-center special" @click="getUserNotifs(props.item.ipv4_address)"> {{ props.item.ipv4_address }}</td>
                                    <td class="text-xs-center special" @click="getUserNotifs(props.item.ipv6_address)"> {{ props.item.ipv6_address }}</td>
                                    !-->
                                    <td @click="getUserNotifs(props.item.ip_address,hoursback)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.asn }}</td>
                                    <!-- <td class="text-xs-center special"> {{ props.item.description }}</td> !-->
                                    <td class="text-xs-center" :style="$store.state.textFormatting.main">
                                        {{ props.item.notification_count }} 
                                        
                                        <v-icon small color="success" :style="$store.state.textFormatting.main" v-if="!props.item.noti_show && props.item.notification_count > 0" @click="viewNotif(props.item)"> add </v-icon> 
                                    
                                        <v-icon color="success" :style="$store.state.textFormatting.main" v-if="props.item.noti_show && props.item.notification_count > 0" small @click="viewNotif(props.item)"> remove </v-icon> 
                                        
                                        <small v-if="props.item.noti_show">
                                            <br />
                                            {{ props.item.notification_str }}
                                        </small>

                                    </td>
                                    <td @click="getUserNotifs(props.item.ip_address,hoursback)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{props.item.ownership_assertion_count}} </td>
                                    <td @click="getUserNotifs(props.item.ip_address,hoursback)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{props.item.path_change_count}} </td>
                                    <td @click="getUserNotifs(props.item.ip_address,hoursback)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{props.item.first_seen_count}} </td>
                                    
                                </tr>
                                
                            </template>
                            <template slot="no-data">
                                <v-alert :value="true" color="success" icon="warning" :style="$store.state.textFormatting.main">
                                    No user prefixes
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
            <br />
        </v-flex>


        <v-flex xs12 xl6 id="top10" class="px-4">

          <v-layout v-if="!showtop10">
              <v-spacer />
              <v-flex shrink>
                  <v-toolbar :color="use_color">
                      <v-btn @click="resetPage" color="success"> Reset/ show all alerts </v-btn>
                  </v-toolbar>
                  <br />
              </v-flex>
              <v-spacer />
              
          </v-layout>
          <top10 v-if="showtop10&&org_user=='org'" v-on:changeAlerts="changeTop10Alerts"></top10>
          <top10 overarching_type="user" v-if="showtop10&&org_user=='user'"></top10>
            <v-flex xs12 class="px-0 py-0" v-if="!showtop10">
                <v-toolbar :color="colorpick" dark flat>
                    <v-toolbar-title :style="$store.state.textFormatting.headers">
                        Alerts Over Time 
                        <span v-if="org_user=='user'"> - {{ username }} </span>
                        <span v-if="org_user=='org'"> - {{ organisation }} </span>
                        <!--<span v-if="currentASN">: {{ currentASN }} </span>-->
                    </v-toolbar-title>
                    <v-progress-circular v-if="asnLoad" indeterminate color="purple"></v-progress-circular>
                    <v-spacer />
                    <v-btn @click="showbubble=!showbubble" class="mx-2" small fab color="blue" dark v-if="!showbubble"> <h2> + </h2> </v-btn>
                    <v-btn @click="showbubble=!showbubble" class="mx-2" small fab color="blue" dark v-if="showbubble"> <h2> - </h2> </v-btn>
                    <info>
                        <template slot>
                            Alerts over time bubble graph (specific ASN/ prefix)
                        </template>
                        <template slot="body">
                            <p> Displays selected alerts, for a prefix/ ASN of interest to your organisation/ user. </p>
                            <p> The 'Y' axis is the hijack score of the alert, with the size representing the event count in the selected alert (i.e. how many events have occured with the same base attributes in that 5 minute period). </p>
                            <p> Click on a bubble to bring up the alert in a table below. </p>
                            <p> This can then be clicked to bring up the alert details page. </p>
                        </template>
                    </info>
                </v-toolbar>
                <v-card v-if="bubbleData&&showbubble">
                    <v-layout justify-center align-center>
                        <v-flex class="px-8 py-2 text-xs-center">
                            <bubbleGraph style="height:30vh" :chart-data="bubbleData"  :options="options" :key="id"> </bubbleGraph>
                        </v-flex>
                    </v-layout>
                </v-card>
                <v-card v-if="bubble_alert&&showbubble">
                    <v-card-text>
                        <v-flex>
                        <v-data-table
                            :headers="bubbleHeaders"
                            :items="bubble_alert"
                            :key="id"
                            hide-actions
                        >
                            <template slot="headerCell" slot-scope="props">
                                <v-tooltip top eager>
                                <span slot="activator" :style="$store.state.textFormatting.main">
                                    <div v-for="line in props.header.text" :key="line.index">
                                        <div> {{ line }} </div>
                                    </div>
                                </span>
                                <span :style="$store.state.textFormatting.main">
                                    {{ props.header.ad_text }}
                                </span>
                                </v-tooltip>
                            </template>
                            <template slot="items" slot-scope="props">
                            <tr>

                                <td
                                @click="clickHandleAlert(props.item)"
                                class="text-xs-center"
                                :style="$store.state.textFormatting.main"
                                >{{ props.item.alert_type }}</td>
                                <td
                                @click="clickHandleAlert(props.item)"
                                class="text-xs-center"
                                :style="$store.state.textFormatting.main"
                                >{{ props.item.prefix }}</td>
                                <td
                                @click="clickHandleAlert(props.item)"
                                class="text-xs-center"
                                :style="$store.state.textFormatting.main"
                                >{{ props.item.non_direct_prefix }}</td>
                                <td @click="clickHandleAlert(props.item)"  v-if="is_asn_owners" class="text-xs-center special" :style="$store.state.textFormatting.main">
                                    <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.origin_asn_old]">
                                        <template v-slot:activator="{ on }">
                                            <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.origin_asn_old }}</div>
                                        </template>
                                        <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.origin_asn_old] }}</span>
                                    </v-tooltip>
                                    <div v-if="!asn_own_dict[props.item.origin_asn_old]" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_old }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                                </td>

                                <td @click="clickHandleAlert(props.item)"  v-if="is_asn_owners" class="text-xs-center special" :style="$store.state.textFormatting.main">
                                    <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.origin_asn_new]">
                                        <template v-slot:activator="{ on }">
                                            <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.origin_asn_new }}</div>
                                        </template>
                                        <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.origin_asn_new] }}</span>
                                    </v-tooltip>
                                    <div v-if="!asn_own_dict[props.item.origin_asn_new]" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_new }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                                </td>
                                <td
                                @click="clickHandleAlert(props.item)"
                                class="text-xs-center"
                                :style="$store.state.textFormatting.main"
                                >{{ props.item.asn_of_interest }}</td>
                                <td
                                @click="clickHandleAlert(props.item)"
                                class="text-xs-center"
                                :style="$store.state.textFormatting.main"
                                >{{ props.item.hijack_score_mean }}</td>
                                <td
                                @click="clickHandleAlert(props.item)"
                                class="text-xs-center"
                                :style="$store.state.textFormatting.main"
                                >{{ props.item.impact_score_mean }}</td>
                                <td
                                @click="clickHandleAlert(props.item)"
                                class="text-xs-center"
                                :style="$store.state.textFormatting.main"
                                >
                                <v-chip
                                    :color="getColor(props.item.interval_start.date)"
                                    text-color="#000000"
                                    dark
                                    :style="$store.state.textFormatting.main"
                                >{{ props.item.interval_start.date }}</v-chip>
                                </td>
                                <td
                                @click="clickHandleAlert(props.item)"
                                class="text-xs-center"
                                :style="$store.state.textFormatting.main"
                                >{{ props.item.interval_start.time }}</td>
                            </tr>
                            </template>
                        </v-data-table>
                        </v-flex>
                    </v-card-text>
                </v-card>
            </v-flex>

            <br  v-if="!showtop10" />


          <v-card v-if="showAlerts && !showevents" id="alerts table">
            <v-toolbar dark flat :color="whoMap[whoIs]">
              <v-toolbar-title :style="$store.state.textFormatting.headers">
                
                <v-tooltip top eager close-delay=500 >
                    <template  v-slot:activator="{ on }">
                        <body slot="activator" v-on="on"> {{ title_str }}  </body>
                    </template>
                    <span :style="$store.state.textFormatting.main"> 
                        Will load the alerts that have happened to the user's selected ASN 
                        <br /> The most recent day's alerts will always appear first 
                        <br /> Then the following most recent alerted day, then the rest of the days 
                    </span>
                </v-tooltip>   
              </v-toolbar-title>
              <v-toolbar-title>
                <v-tooltip top color="secondary">
                    <template v-slot:activator="{ on }">
                        <small v-on="on" :style="$store.state.textFormatting.main"> (select row to see details) </small>         
                    </template>
                    <span :style="$store.state.textFormatting.main">(select row to see details)</span>
                </v-tooltip>
              </v-toolbar-title>
              
              <v-spacer></v-spacer>
              
              <v-tooltip top eager close-delay=500 >
                  <template v-slot:activator="{ on }">
                      <v-toolbar-title v-on="on">
                          <small>
                              <small :style="$store.state.textFormatting.main">
                                  {{ updatedStrASN }}
                              </small>
                          </small>
                      </v-toolbar-title>
                  </template>
                  <span :style="$store.state.textFormatting.main"> {{ updatedStrASN }} </span>
              </v-tooltip>
              
              <info>
                <template slot>
                  Notifications for AS{{currentASN}} ({{currentHoursBack}}H)
                </template>
                <template slot="body">
                  <p>A list of all notifications associated with AS{{currentASN}} and the average Hijack, Impact and Validation scores (see <i><b>GLOSSARY OF TERMS</b></i>) associated with them.</p>
                  
                  <p> Select a notification to view a breakdown of the events associated, as well as a number of visualisations to better understand the ASNs involved.
                  </p>
                  <br>
                  <v-divider />
                  <p> Check the <b>reviewed</b> box and submit the alerts to mark them as reviewed. They will not appear in your alerts in the future. </p>
                  <p> Press the <b>'Show Reviewed Alerts'</b> button to show such alerts again. Check the <b>reviewed</b> box and submit the alerts to <b>insert them back into your live alert flow</b>. </p>

                </template>
              </info>
            </v-toolbar>
            
            <v-flex class="px-4 py-2">
                <v-layout justify="center" align="center" fluid v-if="showAlertsPanel">

                    <v-flex xs3 v-if="freshSliders">
                        <v-tooltip top eager close-delay=500 >
                            <template  v-slot:activator="{ on }">
                                <v-switch slot="activator" v-on="on" 
                                    v-model="exclude_path_change"
                                    @change="getNotificationsForASN(currentASN,currentHoursBack)"
                                    :style="$store.state.textFormatting.main"
                                >
                                <template v-slot:label>
                                        <div :style="$store.state.textFormatting.main">Include path change alerts</div>
                                    </template>
                                </v-switch>
                            </template>
                        <span :style="$store.state.textFormatting.main">Alerts where the old and new origin ASNs are the same, i.e. no change of ownership</span>
                        </v-tooltip>
                    </v-flex>
                    <v-flex xs3 v-if="freshSliders">
                        <v-tooltip top eager close-delay=500 >
                            <template  v-slot:activator="{ on }">
                                <v-switch slot="activator" v-on="on" 
                                    v-model="exclude_first_seen" 
                                    @change="getNotificationsForASN(currentASN,currentHoursBack)"
                                    :style="$store.state.textFormatting.main"
                                >
                                <template v-slot:label>
                                        <div :style="$store.state.textFormatting.main">Include first seen prefix alerts</div>
                                    </template>
                                </v-switch>
                            </template>
                        <span :style="$store.state.textFormatting.main">Alerts where there was no known path to the given prefix, prior to the event occuring (Old ASN = 0)</span>
                        </v-tooltip>
                    </v-flex>
                    <v-flex xs3 v-if="freshSliders">
                        <v-tooltip top eager close-delay=500 >
                            <template  v-slot:activator="{ on }">
                                <v-switch slot="activator" v-on="on"
                                    v-model="exclude_in_path"
                                    @change="getNotificationsForASN(currentASN,currentHoursBack)"
                                    :style="$store.state.textFormatting.main"
                                >
                                <template v-slot:label>
                                    <div :style="$store.state.textFormatting.main">Include ASN in path alerts</div>
                                </template>
                                </v-switch>
                            </template>
                        <span :style="$store.state.textFormatting.main">Alerts where the ASN of interest is in the AS path (i.e. not the origin ASN old or new)</span>
                        </v-tooltip>
                    </v-flex>
                    <v-flex xs3 v-if="freshSliders">
                        <v-tooltip top eager close-delay=500 >
                            <template  v-slot:activator="{ on }">
                                <v-switch slot="activator" v-on="on" 
                                v-model="exclude_own_assert" 
                                label="Include ownership assertions" 
                                @change="getNotificationsForASN(currentASN,currentHoursBack)"
                                :style="$store.state.textFormatting.main"
                                >
                                <template v-slot:label>
                                    <div :style="$store.state.textFormatting.main">Include ownership assertions</div>
                                </template>
                            </v-switch>
                            </template>
                        <span :style="$store.state.textFormatting.main">Alerts where the old and new origin ASN are different i.e. an assertion of ownership over the prefix has occurred</span>
                        </v-tooltip>
                    </v-flex>
                    <v-flex class="py-2 px-1" v-if="allow_dealt" xs4 align-center justify-center>
                        <v-tooltip top eager close-delay=500 >
                            <template  v-slot:activator="{ on }">
                                <v-btn @click="updateDealtWithMany(1)" color="success" v-on="on" :style="$store.state.textFormatting.main"> Update reviewed </v-btn>        
                            </template>
                        <span :style="$store.state.textFormatting.main">Click here to remove the ticked alerts from your organisation's alerts</span>
                        </v-tooltip>
                        
                    </v-flex>

                </v-layout>
            </v-flex>
          
            <v-card-text>
              <v-data-table 
              :headers="headers" :items="data" :expand="expand" :key="id"
              :rows-per-page-items="rowsPerPageItems2" :pagination.sync="pagination2" 
              v-if="!asnLoad && showAlertsPanel"
              >
                <template slot="headerCell" slot-scope="props">
                    <v-tooltip top eager>
                    <span slot="activator" :style="$store.state.textFormatting.main">
                        <div v-for="line in props.header.text" :key="line.index">
                            <div> {{ line }} </div>
                        </div>
                    </span>
                    <span :style="$store.state.textFormatting.main">
                        {{ props.header.ad_text }}
                    </span>
                    </v-tooltip>
                </template>
                <template slot="items" slot-scope="props">
                  <tr>
                                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> 
                                        <v-checkbox class="text-xs-center" hide-details v-if="!props.item.dealt_with_t" v-model="props.item.dealt_with_t" @change="tagDealtWith(props.item, 1)" />
                                        <v-checkbox class="text-xs-center" hide-details v-if="props.item.dealt_with_t" v-model="props.item.dealt_with_t" @change="tagDealtWith(props.item, 0)" />
                                    </td>
                                    
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.alert_type }}</td>
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.prefix }}</td>
                                    <td @click="clickHandleAlert(props.item)"  class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.non_direct_prefix }}</td>
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main">
                                        <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.origin_asn_old]">
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.origin_asn_old }}</div>
                                            </template>
                                            <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.origin_asn_old] }}</span>
                                        </v-tooltip>
                                        <div v-if="!asn_own_dict[props.item.origin_asn_old]" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_old }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                                    </td>
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main">
                                        <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.origin_asn_new]">
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.origin_asn_new }}</div>
                                            </template>
                                            <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.origin_asn_new] }}</span>
                                        </v-tooltip>
                                        <div v-if="!asn_own_dict[props.item.origin_asn_new]" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_new }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                                    </td>
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main">
                                        <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.asn_of_interest]">
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.asn_of_interest }}</div>
                                            </template>
                                            <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.asn_of_interest] }}</span>
                                        </v-tooltip>
                                        <div v-if="!asn_own_dict[props.item.asn_of_interest]" :style="$store.state.textFormatting.main"> {{ props.item.asn_of_interest }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                                    </td>
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.hijack_score_mean }}</td>
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.impact_score_mean }}</td>
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main"> <v-chip class="special" :color="getColor(props.item.interval_start.date)" text-color="#000000" dark :style="$store.state.textFormatting.main">{{ props.item.interval_start.date }}</v-chip> </td>
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.interval_start.time }}</td>
                    </tr>
                </template>
                <template slot="no-data">
                  <v-alert :value="true" color="success" icon="warning" :style="$store.state.textFormatting.main">
                    There have been no alerts for AS{{currentASN}} today.  <v-btn to="/searchEvents" flat outline dark>See more alerts</v-btn>
                  </v-alert>
                </template>
              </v-data-table>
              <v-progress-circular v-if="asnLoad" indeterminate color="purple"></v-progress-circular>
              <v-layout justify-center align-center>
                    <v-flex xs4 class="px-2 py-2">
                        <v-btn color="success" v-if="allow_popped" @click="showPoppedAlerts()" :style="$store.state.textFormatting.main"> Show 'Reviewed' Alerts </v-btn>
                        <v-btn color="success" v-if="!allow_popped" @click="showUnpoppedAlerts()" :style="$store.state.textFormatting.main"> Show Live Alerts </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout justify-center align-center>
                    <v-divider />
                </v-layout>
                
              <v-layout>
                <v-flex xs1 />
                <v-flex xs4 class="px-2 py-2">
                    <downloadcsv
                        class   = "btn btn-default"
                        :data   = "data"
                        name = "asnAlerts.csv">
                            <v-tooltip top eager color="primary" id="exit-app">
                                <template v-slot:activator="{ on }">
                                    <v-btn small dark v-on="on" color="success" :style="$store.state.textFormatting.main"> <v-icon>save_alt</v-icon> 1000 MOST RECENT ALERTS </v-btn>
                                </template>
                                <span :style="$store.state.textFormatting.main">CSV of this ASNs alerts</span>
                            </v-tooltip>
                            
                        </downloadcsv>
                    </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        

        
          <v-card v-if="showContAlerts && !showevents" id="alerts table">
            <v-toolbar dark flat :color="whoMap[whoIs]">
              <v-toolbar-title :style="$store.state.textFormatting.headers">
                
                <v-tooltip top eager close-delay=500 >
                    <template  v-slot:activator="{ on }">
                        <body slot="activator" v-on="on"> {{title_str}} ({{currentHoursBack}}H) </body>
                    </template>
                    <span :style="$store.state.textFormatting.main">Will load the alerts that have happened to the user's selected prefix <br /> The most recent day's alerts will always appear first <br /> Then the following most recent alerted day, then the rest of the days</span>
                </v-tooltip>
              </v-toolbar-title>
              <v-toolbar-title>
                <v-tooltip top color="secondary">
                    <template v-slot:activator="{ on }">
                        <small v-on="on" :style="$store.state.textFormatting.main"> (select row to see details) </small>         
                    </template>
                    <span :style="$store.state.textFormatting.main">(select row to see details)</span>
                </v-tooltip>
              </v-toolbar-title>
              
              <v-spacer></v-spacer>
              <v-tooltip top eager close-delay=500 >
                  <template v-slot:activator="{ on }">
                      <v-toolbar-title v-on="on">
                          <small>
                              <small :style="$store.state.textFormatting.main">
                                  {{ updatedStrCont }}
                              </small>
                          </small>
                      </v-toolbar-title>
                  </template>
                  <span :style="$store.state.textFormatting.main"> {{ updatedStrCont }} </span>
              </v-tooltip>
              
              <info>
                <template slot>
                  Notifications for {{ selectPrefix }}
                </template>
                <template slot="body">
                  <p>A list of all notifications associated with {{selectPrefix}} and the average Hijack, Impact and Validation scores (see <i><b>GLOSSARY OF TERMS</b></i>) associated with them.</p>
                  
                  <p> Select a notification to view a breakdown of the events associated, as well as a number of visualisations to better understand the ASNs involved.
                  </p>
                </template>
              </info>
            </v-toolbar>
            
            <v-flex class="px-4 py-2">
                <v-layout justify="center" align="center" fluid v-if="showContAlertsPanel">
                
                <v-flex xs3>
                    <v-tooltip top eager close-delay=500 >
                        <template  v-slot:activator="{ on }">
                            <v-switch slot="activator"
                                v-on="on" v-model="exclude_path_change" 
                                label="Include path change alerts" 
                                @change="getNotificationsForASN(currentASN,currentHoursBack)"
                                >
                                <template v-slot:label>
                                    <div :style="$store.state.textFormatting.main">Include path change alerts</div>
                                </template>
                            </v-switch>
                        </template>
                    <span :style="$store.state.textFormatting.main">Alerts where the old and new origin ASNs are the same, i.e. no change of ownership</span>
                    </v-tooltip>
                </v-flex>
                <v-flex xs3>
                    <v-tooltip top eager close-delay=500 >
                        <template  v-slot:activator="{ on }">
                            <v-switch slot="activator" 
                            v-on="on" v-model="exclude_first_seen" 
                            label="Include first seen prefix alerts" 
                            @change="getNotificationsForASN(currentASN,currentHoursBack)"
                            >
                            <template v-slot:label>
                                <div :style="$store.state.textFormatting.main">Include first seen prefix alerts</div>
                            </template> 
                            </v-switch>
                        </template>
                    <span :style="$store.state.textFormatting.main">Alerts where there was no known path to the given prefix, prior to the event occuring (Old ASN = 0)</span>
                    </v-tooltip>
                </v-flex>
                <v-flex xs3>
                    <v-tooltip top eager close-delay=500 >
                        <template  v-slot:activator="{ on }">
                            <v-switch slot="activator" 
                            v-on="on" v-model="exclude_in_path" 
                            label="Include ASN in path alerts" 
                            @change="getNotificationsForASN(currentASN,currentHoursBack)"
                            > 
                            <template v-slot:label>
                                <div :style="$store.state.textFormatting.main">Include ASN in path alerts</div>
                            </template>
                            </v-switch>
                        </template>
                    <span :style="$store.state.textFormatting.main">Alerts where the ASN of interest is in the AS path (i.e. not the origin ASN old or new)</span>
                    </v-tooltip>
                </v-flex>
                <v-flex xs3 v-if="freshSliders">
                        <v-tooltip top eager close-delay=500 >
                            <template  v-slot:activator="{ on }">
                                <v-switch slot="activator" 
                                v-on="on" v-model="exclude_own_assert" 
                                label="Include ownership assertions" 
                                @change="getNotificationsForASN(currentASN,currentHoursBack)"
                                >
                                <template v-slot:label>
                                    <div :style="$store.state.textFormatting.main">Include ownership assertions</div>
                                </template>
                                </v-switch>
                            </template>
                        <span :style="$store.state.textFormatting.main">Alerts where the old and new origin ASN are different i.e. an assertion of ownership over the prefix has occurred</span>
                        </v-tooltip>
                    </v-flex>
                    <v-flex class="py-2 px-1" v-if="allow_dealt" xs4 align-center justify-center>
                        <v-tooltip top eager close-delay=500 >
                            <template  v-slot:activator="{ on }">
                                <v-btn @click="updateDealtWithMany(1)" color="success" v-on="on" :style="$store.state.textFormatting.main"> Update reviewed </v-btn>        
                            </template>
                        <span :style="$store.state.textFormatting.main">Click here to remove the ticked alerts from your organisation's alerts</span>
                        </v-tooltip>
                        
                    </v-flex>

                </v-layout>
            </v-flex>
          
            <v-card-text>
              <v-data-table 
              :headers="headers" :items="data" :expand="expand" :key="id"
              :rows-per-page-items="rowsPerPageItems2" :pagination.sync="pagination2" 
              v-if="!asnLoad && showContAlertsPanel"
              >
                <template slot="headerCell" slot-scope="props">
                    <v-tooltip top eager>
                    <span slot="activator" :style="$store.state.textFormatting.main">
                        <div v-for="line in props.header.text" :key="line.index">
                            <div> {{ line }} </div>
                        </div>
                    </span>
                    <span :style="$store.state.textFormatting.main">
                        {{ props.header.ad_text }}
                    </span>
                    </v-tooltip>
                </template>
                <template slot="items" slot-scope="props">
                  <tr>
                                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> 
                                        <v-checkbox class="text-xs-center" hide-details v-if="!props.item.dealt_with_t" v-model="props.item.dealt_with_t" @change="tagDealtWith(props.item, 1)" />
                                        <v-checkbox class="text-xs-center" hide-details v-if="props.item.dealt_with_t" v-model="props.item.dealt_with_t" @change="tagDealtWith(props.item, 0)" />
                                    </td>
                                    
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.alert_type }}</td>
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.prefix }}</td>
                                    <td @click="clickHandleAlert(props.item)"  class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.non_direct_prefix }}</td>
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main">
                                        <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.origin_asn_old]">
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.origin_asn_old }}</div>
                                            </template>
                                            <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.origin_asn_old] }}</span>
                                        </v-tooltip>
                                        <div v-if="!asn_own_dict[props.item.origin_asn_old]" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_old }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                                    </td>
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main">
                                        <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.origin_asn_new]">
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.origin_asn_new }}</div>
                                            </template>
                                            <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.origin_asn_new] }}</span>
                                        </v-tooltip>
                                        <div v-if="!asn_own_dict[props.item.origin_asn_new]" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_new }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                                    </td>
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.asn_of_interest }} </td>
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.hijack_score_mean }}</td>
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.impact_score_mean }}</td>
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main"> <v-chip class="special" :color="getColor(props.item.interval_start.date)" text-color="#000000" dark :style="$store.state.textFormatting.main">{{ props.item.interval_start.date }}</v-chip> </td>
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.interval_start.time }}</td>
                    </tr>
                </template>
                <template slot="no-data">
                  <v-alert :value="true" color="success" icon="warning" :style="$store.state.textFormatting.main">
                    There have been no alerts for {{currentASN}} today.  <v-btn to="/searchEvents" flat outline dark>See more alerts</v-btn>
                  </v-alert>
                </template>
              </v-data-table>
              <v-progress-circular v-if="asnLoad" indeterminate color="purple"></v-progress-circular>
              <v-layout justify-center align-center>
                    <v-flex xs4 class="px-2 py-2">
                        <v-btn color="success" v-if="allow_popped" @click="showPoppedAlerts()" :style="$store.state.textFormatting.main"> Show 'Reviewed' Alerts </v-btn>
                        <v-btn color="success" v-if="!allow_popped" @click="showUnpoppedAlerts()" :style="$store.state.textFormatting.main"> Show Live Alerts </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout justify-center align-center>
                    <v-divider />
                </v-layout>
              <v-layout>
                <v-flex xs1 />
                <v-flex xs4 class="px-2 py-2">
                    <downloadcsv
                        class   = "btn btn-default"
                        :data   = "data"
                        name = "prefixAlerts.csv">
                            <v-tooltip top eager color="primary" id="exit-app">
                                <template v-slot:activator="{ on }">
                                    <v-btn small dark v-on="on" color="success" :style="$store.state.textFormatting.main"> <v-icon>save_alt</v-icon> 1000 MOST RECENT ALERTS </v-btn>
                                </template>
                                <span :style="$store.state.textFormatting.main">CSV of this prefix's alerts</span>
                            </v-tooltip>
                            
                        </downloadcsv>
                    </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        
        
      </v-layout>
  </v-container>
</template>


<script>
import { API, graphqlOperation } from 'aws-amplify';
//import BarChart from '../../shared/operational/BarChart.js';
import info from '../../shared/operational/infopopout.vue';
import top10 from '../../shared/operational/top-10-liveupdate.vue';
//import top10user from '../../shared/operational/top-10-user.vue';
import asnlist from '../../shared/operational/asn-list-thresholds.vue';
import asnlistuser from '../../shared/operational/asn-list-thresholds-user.vue';
import asnrules from '../../shared/operational/asn-rules.vue';
import userorgrules from '../../shared/operational/userorg-rules.vue';
import { alerttable, eventtable } from '../../shared/operational/infopopout.js';
//import asnpathchange from '../../shared/developing/asn-path-change.vue'
import downloadcsv from 'vue-json-csv';
//import prefixRouting from '../../shared/developing/prefix-routing.vue'
import { findParentComponentByName } from '../utils/findParent.js';
import bubbleGraph from '../../shared/developing/bubble-graph.js';
import OldRules from '../settings/oldRules.vue';


export default {
  name: 'splitalerts',
  components: {
    //BarChart,
    info,
    top10,
    asnlist,
    //asnpathchange,
    downloadcsv,
    //prefixRouting,
    //top10user,
    asnlistuser,
    asnrules,
    userorgrules,
    bubbleGraph,
    OldRules
},
  data () {
    return {
        orderByList2: [
            {name: "6h", param: "6"},
            {name: "12h", param: "12"},
            {name: "24h", param: "24"},
            {name: "48h", param: "48"},
            {name: "72h", param: "72"}
        ],
      TestforPushingStuff: false,
      freshSliders: true,
      notificationType: "org",
      orderByList: [
        {name: "New ASN", param: "origin_asn_new"},
        {name: "Old ASN", param: "origin_asn_old"},
        {name: "Time", param: "time_5min"},
        {name: "Hijack Score", param: "hijack_score_mean"},
        {name: "Impact Score", param: "impact_score_mean"},
        {name: "Validation Score", param: "event_count"}
      ],
      orderedStr: "Hijack Score",
      exclude_first_seen: false,
      exclude_path_change: false,
      exclude_in_path: false,
      exclude_own_assert: false,
      oldAndNewPath: [],
      asnLoad: false,
      testPathChange: true,
      graphdata: [],
      alerttableinfo: alerttable,
      eventtableinfo: eventtable,
      headinfoalertstable: "Header",
      bodyinfoalertstable: "Body",
      myData: "",
      whoIs: "Org",
      showevents: false,
      showtop10: true,
      radios: null,
      rowsPerPageItems: [20, 30, 40, 50],
      pagination: {
        rowsPerPage: 10
        },
      rowsPerPageItems2: [20, 30, 40, 50],
      pagination2: {
        rowsPerPage: 10
        },
      id: 1,
      idForPath:0,
      graphs: true,
      alertcount: null,
      alertdata: [],
      analytics: null,
      expand: true,
      showAlerts: false,
      headers: [
            { text: ['Reviewed'], sortable: false, value: 'dealt_with_t', align: 'centre', ad_text: 'Check the box and submit the alerts and they will not appear in your organisation alerts any longer'},
            { text: ['Alert Type'], value: 'alert_type', align:'centre', ad_text: 'The type of alert, see glossary for details'},
            { text: ['Advertised', 'Prefix'], value:'prefix', align:'centre', ad_text: 'Prefix of the alert'},
            { text: ['Sub/Super', 'Ownership', 'Prefix'], value:'non_direct_prefix', align:'centre', ad_text: 'Where a sub/super ownership assertion occurs, this will display the parent/child prefix of the alert'},
            { text: ['Old', 'ASN'], value:'origin_asn_old', align:'centre', ad_text: 'Former ASN, having ownership asserted upon'},
            { text: ['New', 'ASN'], value:'origin_asn_new', align:'centre', ad_text: 'New ASN asserting ownership'},
            { text: ['ASDASD', 'Matched', 'ASN/ Prefix'], value: 'asn_of_interest', align:'centre', ad_text: 'ASN or restricted prefix designated by user which generated this alert'},
            { text: ['Hijack', 'Score'], value: 'hijack_score_mean', align:'centre', ad_text: 'Hijack score of alert'},
            { text: ['Impact', 'Score'], value: 'impact_score_mean', align:'centre', ad_text: 'Impact score of alert'},
            { text: ['Date'], value:'time_5min', align:'centre', ad_text: 'Date'},
            { text: ['Time'], value:'time_5min', align:'centre', ad_text: 'Time of alert'}
        ],
      headers2: [     
        { text: 'Reviewed', sortable: false, value: 'dealt_with_t', align: 'centre', ad_text: 'Check the box and submit the alerts and they will not appear in your organisation alerts any longer'},
      //  { text: 'User ASN', value: 'asn_of_interest', align:'centre', ad_text: 'ASN designated by user which generated this alert'},
        { text: 'Prefix', value:'prefix', align:'centre', ad_text: 'Prefix of the alert'},
        { text: 'Old ASN', value:'origin_asn_old', align:'centre', ad_text: 'Former ASN, having ownership asserted upon'},
        { text: 'New ASN', value:'origin_asn_new', align:'centre', ad_text: 'New ASN asserting ownership'},
        { text: 'H', value: 'hijack_score_mean', align:'centre', ad_text: 'Hijack score of alert'},
        { text: 'I', value: 'impact_score_mean', align:'centre', ad_text: 'Impact score of alert'},
        //{ text: 'V', values: 'validation',sortable: false, align:'centre'},
        { text: 'Date', value:'time_5min', align:'centre', ad_text: 'Date'},
        { text: 'Time', value:'time_5min', align:'centre', ad_text: 'Time of alert'}
      ],
      data:[],
      data2: [],
      currentASN: '',
      eventdata: [],
      headinfo1: 'Alert Page info',
      bodyinfo2: 'All alerts for users will be seen here. Users can select which AS to visualise alerts for and can select an alert to see the events which came together to form this alert. Also present are graphic visualisations of the data at hand and the analytics which have formed the alert.',
      page_offset: 0,
      page_rows: 2000,
      order_by: "event_count",
      UserDownloadData: [],
      currentEpisodeData: [],
      userPrefixes: [],
      orgPrefixes: [],
      contLoading: false,
      contPrefixHeaders: [
        { text: 'Hostname', value:'hostname', align:'centre', ad_text: 'User designated hostname'},
        { text: 'IP Address', value:'ipv4_address', align:'centre', ad_text: 'User designated IPv4/6 network range'},
        { text: 'ASN', value:'asn', align:'centre', ad_text: 'For housekeeping: ASN associated to the prefix (no function in alerts)'},
        { text: 'Alert Count (24h)', value:'notification_count', align:'centre', ad_text: 'Count of alerts created from this range'},
        { text: 'Own. Assertions', value:'ownership_assertion_count', align:'centre', ad_text: 'Alerts where the origin ASN has changed from one to another'},
        { text: 'Path Change', value:'path_change_count', align:'centre', ad_text: "Alerts where the origin ASN hasn't changed"},
        { text: 'First Seen', value:'first_seen_count', align:'centre', ad_text: "Alerts where the prefix has no owner prior to the alert occuring"},
      ],
      showContAlerts: false,
      selectPrefix: "",
      showOrgCont: false,
      showUserCont: false,
      showAlertsPanel: false,
      showContAlertsPanel: false,
      allowExcludeSwitches: false,
      whoMap: {
          User: 'accent',
          Org: 'secondary'
      },
      top10org: true,
      to_be_dealt: [],
      allow_dealt: false,
      show_popped: '',
      allow_popped: true,
      currentHoursBack: 24,
      hoursback: 24,
      org_user: 'org',
      organisation: '',
      username: "",
      use_color: 'secondary',
      updatedStr: "",
      updatedStrCont: "",
      updatedStrASN: "",
      asn_own_dict: {},
      asn_get_owner: [],
      showbubble: false,
      is_asn_owners: true,
        bubbleHeaders: [
            //{ text: ['Reviewed'], sortable: false, value: 'dealt_with_t', align: 'centre', ad_text: 'Check the box and submit the alerts and they will not appear in your organisation alerts any longer'},
            { text: ['Alert Type'], value: 'alert_type', align:'centre', ad_text: 'The type of alert, see glossary for details'},
            { text: ['Advertised', 'Prefix'], value:'prefix', align:'centre', ad_text: 'Prefix of the alert'},
            { text: ['Sub/Super', 'Ownership', 'Prefix'], value:'non_direct_prefix', align:'centre', ad_text: 'Where a sub/super ownership assertion occurs, this will display the parent/child prefix of the alert'},
            { text: ['Old', 'ASN'], value:'origin_asn_old', align:'centre', ad_text: 'Former ASN, having ownership asserted upon'},
            { text: ['New', 'ASN'], value:'origin_asn_new', align:'centre', ad_text: 'New ASN asserting ownership'},
            { text: ['ASDASD', 'Matched', 'ASN/ prefix'], value: 'asn_of_interest', align:'centre', ad_text: 'ASN or restricted prefix designated by user which generated this alert'},
            { text: ['Hijack', 'Score'], value: 'hijack_score_mean', align:'centre', ad_text: 'Hijack score of alert'},
            { text: ['Impact', 'Score'], value: 'impact_score_mean', align:'centre', ad_text: 'Impact score of alert'},
            { text: ['Date'], value:'time_5min', align:'centre', ad_text: 'Date'},
            { text: ['Time'], value:'time_5min', align:'centre', ad_text: 'Time of alert'}
        ],
        bubbleMaxSize: 20,
        bubbleMinSize: 3,
        bubbleData: null,
        bubble_alert: false,
        options: {
                animation: {
                    duration: 0 // general animation time
                },
                hover: {
                    animationDuration: 0 // duration of animations when hovering an item
                },
                responsiveAnimationDuration: 0, // animation duration after a resize
                onClick: this.chartHandle,
                passive: true,
                //aspectRatio: 0.2,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        left: 50,
                        right: 50,
                        top: 50,
                        bottom: 50
                    }
                },
                legend: {
                    labels: {
                        // This more specific font property overrides the global property
                        fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                    }
                },
                tooltips: {
                    bodyFontSize: this.$store.state.textFormatting.traceroute.fontSize + 10,
                    callbacks: {
                        label: function(tooltipItem, data ) {
                            try {
                                var eventCount = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].ev_count
                                if (eventCount ==50) {
                                    eventCount= "50+"
                                }
                                var comboScore = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y
                                var epochTime = tooltipItem.xLabel
                                var d_t = new Date( epochTime *1000);
                                var date = d_t.toLocaleString().substr(0, 10);
                                var time = d_t.toLocaleString().substr(11, 9);
                                var label = "Event Count: "+eventCount+", Hijack Score: " +comboScore+", Date: " +date + ", Time: " + time

                                return label
                                }
                                catch(err) {
                                    console.log(err)
                            }
                        }
                    }
                },
                responsive: true,
                
                scales: {
                    yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Hijack Score (H)',
                            fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                        },
                        ticks: {
                            min: 0,
                            stepSize: 20,
                            max: 100,
                            fontSize: this.$store.state.textFormatting.chart.axis_label
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            fontSize: this.$store.state.textFormatting.chart.axis_label,
                            callback: (value, index, values) => {
                                var dataPointEpochTimeInHRFormat = new Date (value *1000);
                                let dateTime = dataPointEpochTimeInHRFormat.toLocaleString().split(", ");
                                return dateTime[0].split("/")[0] + "/" + dateTime[0].split("/")[1] + " " + dateTime[1].split(":")[0] + ":" + dateTime[1].split(":")[1];  
                            }
                        }
                    }]
                },
                pan: {
                    enabled: true,
                    passive: true,
                    mode: 'x'
                },
                zoom: {
                    enabled: true,
                    passive: true,
                    mode: 'x',
                }
            },
        colors: [
            'tertiary',
            'secondary',
            'accent'
        ],
        colorpick: 'secondary',
        prefixRules: []
            
    }; 
  },
  mounted () {

    if ( this.org_user == 'user') {
        this.use_color = 'accent'
    } else {
        this.use_color = 'secondary'
    }

    this.exclude_path_change = this.$store.state.alertsExcPath
    this.exclude_first_seen = this.$store.state.alertsExcFirst
    this.exclude_in_path = this.$store.state.alertsExcInPath
    this.exclude_own_assert = this.$store.state.alertsExcOwnAssert
    this.freshSliders = false;
    this.$nextTick(() => {
    // Add the component back in
    this.freshSliders = true;
    });
    this.asnNuserINfo
    this.getControlledPrefixes();
    this.allowExcludeSwitches = true;
  },
  beforeMount() {
        if (this.$attrs.type) {
            this.org_user = this.$attrs.type;
        }
        try {
            this.organisation = this.$store.state.user.organisation;
            this.username = this.$store.state.user.username;
            if (this.org_user == 'org') {
                this.headers[6].text[0] = this.organisation;
                this.colorpick = this.colors[1]
            } else {
                this.headers[6].text[0] = this.username;
                this.colorpick = this.colors[2]
            }
        } catch (err) {
            console.log(err)
            location.reload()
        }
        this.showOrgCont = this.$store.state.showSettings.showOrgResSummary;
        this.showUserCont = this.$store.state.showSettings.showUserResSummary;
        this.showbubble = this.$store.state.showSettings.showBubble;
        let app = findParentComponentByName(this, 'app')
        app.checkSignedIn()
  },
  methods: {
    refreshList: async function (n) {
        this.hoursback = n;
        if (this.org_user=='org') {
            this.getControlledPrefixes('org')
            this.getControlledPrefixCounts('org')
        } else {
            this.getControlledPrefixes('user')
            this.getControlledPrefixCounts('user')
        }
        this.contPrefixHeaders[3].text = "Alert Count (" + n + "h)";
    },
    resetPage: async function () {
        this.currentHoursBack = 24;
        this.showtop10 = true
        this.showAlerts = false
        this.showContAlerts = false
    },
    viewNotif: async function (item) {
        item.noti_show = !item.noti_show;
        this.contLoading = true;
        this.$nextTick(() => {
        // Add the component back in
        this.contLoading = false;
        });

    },
    getColor: function (indate) {
                let d_obj = new Date();
                let day = ("0" + d_obj.getUTCDate()).slice(-2);
                let mon = ("0" + (d_obj.getUTCMonth() + 1)).slice(-2);
                let yr = d_obj.getUTCFullYear();
                let fdate = day + "/" + mon + "/" + yr;

                d_obj.setDate(d_obj.getUTCDate() - 1);
                let day2 = ("0" + d_obj.getUTCDate()).slice(-2);
                let mon2 = ("0" + (d_obj.getUTCMonth() + 1)).slice(-2);
                let yr2 = d_obj.getUTCFullYear();
                let yfdate = day2 + "/" + mon2 + "/" + yr2;

                if (fdate == indate) {
                    return '#FF6347'
                } else if ( yfdate == indate ) {
                    return '#FFDAB9'
                } else {
                    return '#ffffff'
                }
    },
    changeOrderBy: function (order) {
      
            this.order_by = order
            this.getNotificationsForASN(this.currentASN,this.currentHoursBack);
            for (var i = 0; i<this.orderByList.length ; i++) {
              if (this.orderByList[i].param == order) {
                this.orderedStr = this.orderByList[i].name;
              }
            }
      
        
    },
    getControlledPrefixes: async function () {
        var dd = Math.floor((new Date() / 1000) - 3600 * this.hoursback);
        this.contLoading = true;
        if (this.org_user == 'org') {
            try {
                var prefsQuery = `query getControlledPrefixesSummary { getControlledPrefixesSummary(
                    organisation: "` + this.$store.state.user.organisation +`"
                    time_from: ` + dd + `
                ) { 
                        hostname
                        ipv4_address
                        ipv6_address
                        asn
                        description
                        own_path_first
                        emails_opf } 
                    }`;
//               console.log(prefsQuery)
                const prefData = await API.graphql(graphqlOperation(prefsQuery));
//               console.log(prefData)
                var prefs = prefData.data.getControlledPrefixesSummary;

                if (prefs.length == 0 || prefs === undefined) {
                    this.orgPrefixes = [];
                } else {
                    for (var i = 0 ; i < prefs.length ; i++ ) {
                        if ( prefs[i].ipv4_address != '') {
                            prefs[i].ip_address = prefs[i].ipv4_address
                        } else {
                            prefs[i].ip_address = prefs[i].ipv6_address
                        }
                        try {
                                prefs[i].opf_split = prefs[i].own_path_first.split("")
                                for ( var j = 0 ; j < prefs[i].opf_split.length ; j++ ) {
                                    prefs[i].opf_split[j] = prefs[i].opf_split[j] == 1 ? true : false;
                                }
                            } catch (e) {
                                console.log(e)
                                prefs[i].opf_split = [true, false, false, false]
                            }

                            try {
                                prefs[i].opf_split_e = prefs[i].emails_opf.split("")
                                for ( var j = 0 ; j < prefs[i].opf_split_e.length ; j++ ) {
                                    prefs[i].opf_split_e[j] = prefs[i].opf_split_e[j] == 1 ? true : false;
                                }
                            } catch (e) {
                                console.log(e)
                                prefs[i].opf_split_e = [false, false, false, false]
                            }

                    }
                    this.orgPrefixes = prefs;
                }
            } catch(err) {
                console.log( err)
                console.log("An Error has occurred: " + err.errors[0].message)
            }
            this.contLoading = false;
            this.getControlledPrefixCounts('organisation');

        } else {
            try {
                var prefsQuery = `query getControlledPrefixesSummary { getControlledPrefixesSummary(
                    organisation: "` + this.$store.state.user.organisation +`"
                    p_user: "` + this.$store.state.user.username + `"
                    time_from: ` + dd + `

                ) { 
                    hostname
                    ipv4_address
                    ipv6_address
                    asn
                    description
                    own_path_first
                    emails_opf } 
                }`;
//                console.log(prefsQuery);
                const prefData = await API.graphql(graphqlOperation(prefsQuery));
//                console.log(prefData)
                var prefs = prefData.data.getControlledPrefixesSummary;

                if (prefs.length == 0 || prefs === undefined) {
                    this.userPrefixes = [];
                } else {
                    for (var i = 0 ; i < prefs.length ; i++ ) {
                        if ( prefs[i].ipv4_address != '') {
                            prefs[i].ip_address = prefs[i].ipv4_address
                        } else {
                            prefs[i].ip_address = prefs[i].ipv6_address
                        }
                        try {
                                prefs[i].opf_split = prefs[i].own_path_first.split("")
                                for ( var j = 0 ; j < prefs[i].opf_split.length ; j++ ) {
                                    prefs[i].opf_split[j] = prefs[i].opf_split[j] == 1 ? true : false;
                                }
                            } catch (e) {
                                console.log(e)
                                prefs[i].opf_split = [true, false, false]
                            }

                            try {
                                prefs[i].opf_split_e = prefs[i].emails_opf.split("")
                                for ( var j = 0 ; j < prefs[i].opf_split_e.length ; j++ ) {
                                    prefs[i].opf_split_e[j] = prefs[i].opf_split_e[j] == 1 ? true : false;
                                }
                            } catch (e) {
                                console.log(e)
                                prefs[i].opf_split_e = [false, false, false]
                            }

                    }
                    this.userPrefixes = prefs;
                }
            } catch(err) {
                console.log( err)
                console.log("An Error has occurred: " + err.errors[0].message)
            }
            this.contLoading = false;
            this.getControlledPrefixCounts('user');  
        }
      
    },
    getControlledPrefixCounts: async function (usr) {
        try {

            if (usr == 'user') {
                var p_user = this.$store.state.user.username;
            } else {
                var p_user = 'whole_organisation'
            }
    //        console.log("USERSSSSSs")
     //       console.log(p_user)

            var dd = Math.floor((new Date() / 1000) - 3600 * this.hoursback);
            var query = `query getNotificationsPerControlledPrefix {
                getNotificationsPerControlledPrefix(
                    start_time: ` + dd + `,
                    organisation: "` + this.$store.state.user.organisation + `",
                    p_user: "` + p_user + `",
                    ) {
                        prefix
                        controlled_prefix
                        event_count
                        path_change_count
                        first_seen_count
                        ownership_assertion_count
                    }
                }`
        //    console.log(query)
            const response = await API.graphql(graphqlOperation(query));
        //    console.log(response)
            var results = response.data.getNotificationsPerControlledPrefix
            if (results) {
                if (results.length > 0) {
                    var cPreDicts = {};

                    for (var i = 0; i < results.length ; i++) {
                        var pre = results[i].prefix;
                        var cPre = results[i].controlled_prefix
                        var count = results[i].event_count
                        var pc = results[i].path_change_count
                        var fs = results[i].first_seen_count
                        var oa = results[i].ownership_assertion_count
                        if (!(cPre in cPreDicts)) {
                            cPreDicts[cPre] = {
                                "total": 0,
                                "path_change": 0,
                                "first_seen": 0,
                                "ownership_assertion": 0
                            }
                        }
                        if (pre in cPreDicts[cPre]) {
                            cPreDicts[cPre][pre] += count
                        } else {
                            cPreDicts[cPre][pre] = count
                        }
                        cPreDicts[cPre]["total"] += count
                        cPreDicts[cPre]["path_change"] += pc
                        cPreDicts[cPre]["first_seen"] += fs
                        cPreDicts[cPre]["ownership_assertion"] += oa
                    }
                 //   console.log(cPreDicts)
                    if (usr == "user") {
                        for (var j = 0; j < this.userPrefixes.length; j++) {
                            var entries = []
                            if (this.userPrefixes[j].ipv4_address in cPreDicts) {
                                var preDict = cPreDicts[this.userPrefixes[j].ipv4_address];
                 //               console.log(preDict)
                                this.userPrefixes[j].notification_count = preDict["total"]
                                this.userPrefixes[j].first_seen_count = this.userPrefixes[j].opf_split[2] ? preDict["first_seen"] : '#N/A'          // If the user has set not to recieve the given type of alerts we put N/A rater than zero
                                this.userPrefixes[j].path_change_count = this.userPrefixes[j].opf_split[1] ? preDict["path_change"] : '#N/A'
                                this.userPrefixes[j].ownership_assertion_count = this.userPrefixes[j].opf_split[0] ? preDict["ownership_assertion"] : '#N/A'
                                var keys = Object.keys(preDict);
                                //console.log(keys)
                                for (var k =0; k < keys.length ; k++) {
                                    const ignore = ['total', 'first_seen', 'path_change', 'ownership_assertion']
                                    if (!(ignore.includes(keys[k]))) {
                                        entries.push(keys[k] + ": " + preDict[keys[k]])
                                    }
                                }
                                
                            } else if (this.userPrefixes[j].ipv6_address in cPreDicts) {
                                var preDict = cPreDicts[this.userPrefixes[j].ipv6_address];
                                this.userPrefixes[j].notification_count += preDict["total"]
                                this.userPrefixes[j].first_seen_count = this.userPrefixes[j].opf_split[2] ? preDict["first_seen"] : '#N/A'          // If the user has set not to recieve the given type of alerts we put N/A rater than zero
                                this.userPrefixes[j].path_change_count = this.userPrefixes[j].opf_split[1] ? preDict["path_change"] : '#N/A'
                                this.userPrefixes[j].ownership_assertion_count = this.userPrefixes[j].opf_split[0] ? preDict["ownership_assertion"] : '#N/A'
                                var keys = Object.keys(preDict);
                                //console.log(keys)
                                for (var k =0; k < keys.length ; k++) {
                                    const ignore = ['total', 'first_seen', 'path_change', 'ownership_assertion']
                                    if (!(ignore.includes(keys[k]))) {
                                        entries.push(keys[k] + ": " + preDict[keys[k]])
                                    }
                                }
                            } else {
                                this.userPrefixes[j].notification_count = 0
                                this.userPrefixes[j].first_seen_count = this.userPrefixes[j].opf_split[2] ? 0 : '#N/A'          // If the user has set not to recieve the given type of alerts we put N/A rater than zero
                                this.userPrefixes[j].path_change_count = this.userPrefixes[j].opf_split[1] ? 0 : '#N/A'
                                this.userPrefixes[j].ownership_assertion_count = this.userPrefixes[j].opf_split[0] ? 0 : '#N/A'
                            }
                            this.userPrefixes[j].notification_str = entries.join(", ")
                            this.userPrefixes[j].noti_show = false;
                            this.contLoading = true;
                            this.$nextTick(() => {
                            // Add the component back in
                            this.contLoading = false;
                            });
                        }
                    } else {
                        for (var j = 0; j < this.orgPrefixes.length; j++) {
                            var entries = []
                            if (this.orgPrefixes[j].ipv4_address in cPreDicts) {
                                var preDict = cPreDicts[this.orgPrefixes[j].ipv4_address];
                    //            console.log(preDict)
                                this.orgPrefixes[j].notification_count = preDict["total"]
                                this.orgPrefixes[j].first_seen_count = this.orgPrefixes[j].opf_split[2] ? preDict['first_seen'] : '#N/A'          // If the org has set not to recieve the given type of alerts we put N/A rater than zero
                                this.orgPrefixes[j].path_change_count = this.orgPrefixes[j].opf_split[1] ? preDict['path_change'] : '#N/A'
                                this.orgPrefixes[j].ownership_assertion_count = this.orgPrefixes[j].opf_split[0] ? preDict['ownership_assertion'] : '#N/A'
                                var keys = Object.keys(preDict);
                                //console.log(keys)
                                for (var k =0; k < keys.length ; k++) {
                                    const ignore = ['total', 'first_seen', 'path_change', 'ownership_assertion']
                                    if (!(ignore.includes(keys[k]))) {
                                        entries.push(keys[k] + ": " + preDict[keys[k]])
                                    }
                                }
                                
                            } else if (this.orgPrefixes[j].ipv6_address in cPreDicts) {
                                var preDict = cPreDicts[this.orgPrefixes[j].ipv6_address];
                                this.orgPrefixes[j].notification_count += preDict["total"]
                                this.orgPrefixes[j].first_seen_count = this.orgPrefixes[j].opf_split[2] ? preDict['first_seen'] : '#N/A'          // If the org has set not to recieve the given type of alerts we put N/A rater than zero
                                this.orgPrefixes[j].path_change_count = this.orgPrefixes[j].opf_split[1] ? preDict['path_change'] : '#N/A'
                                this.orgPrefixes[j].ownership_assertion_count = this.orgPrefixes[j].opf_split[0] ? preDict['ownership_assertion'] : '#N/A'
                                var keys = Object.keys(preDict);
                                //console.log(keys)
                                for (var k =0; k < keys.length ; k++) {
                                    const ignore = ['total', 'first_seen', 'path_change', 'ownership_assertion']
                                    if (!(ignore.includes(keys[k]))) {
                                        entries.push(keys[k] + ": " + preDict[keys[k]])
                                    }
                                }
                            } else {
                                this.orgPrefixes[j].notification_count = 0
                                this.orgPrefixes[j].first_seen_count = this.orgPrefixes[j].opf_split[2] ? 0 : '#N/A'          // If the org has set not to recieve the given type of alerts we put N/A rater than zero
                                this.orgPrefixes[j].path_change_count = this.orgPrefixes[j].opf_split[1] ? 0 : '#N/A'
                                this.orgPrefixes[j].ownership_assertion_count = this.orgPrefixes[j].opf_split[0] ? 0 : '#N/A'   
                            }
                            this.orgPrefixes[j].notification_str = entries.join(", ")
                            this.orgPrefixes[j].noti_show = false;
                            this.contLoading = true;
                            this.$nextTick(() => {
                            // Add the component back in
                            this.contLoading = false;
                            });
                        }
                    }
                    

                } else {
                    if (usr == "user") {
                        for (var j = 0; j < this.userPrefixes.length; j++) {
                            this.userPrefixes[j].notification_count = 0
                            this.userPrefixes[j].first_seen_count = this.userPrefixes[j].opf_split[2] ? 0 : '#N/A'          // If the user has set not to recieve the given type of alerts we put N/A rater than zero
                            this.userPrefixes[j].path_change_count = this.userPrefixes[j].opf_split[1] ? 0 : '#N/A'
                            this.userPrefixes[j].ownership_assertion_count = this.userPrefixes[j].opf_split[0] ? 0 : '#N/A'
                            this.userPrefixes[j].notification_str = ""
                        }
                    } else {
                        for (var j = 0; j < this.orgPrefixes.length; j++) {
                            this.orgPrefixes[j].notification_count = 0
                            this.orgPrefixes[j].first_seen_count = this.orgPrefixes[j].opf_split[2] ? 0 : '#N/A'          // If the org has set not to recieve the given type of alerts we put N/A rater than zero
                            this.orgPrefixes[j].path_change_count = this.orgPrefixes[j].opf_split[1] ? 0 : '#N/A'
                            this.orgPrefixes[j].ownership_assertion_count = this.orgPrefixes[j].opf_split[0] ? 0 : '#N/A'   
                            this.orgPrefixes[j].notification_str = ""
                        }
                    }
                }
            } else {
                if (usr == "user") {
                    for (var j = 0; j < this.userPrefixes.length; j++) {
                        this.userPrefixes[j].notification_count = 0
                        this.userPrefixes[j].first_seen_count = this.userPrefixes[j].opf_split[2] ? 0 : '#N/A'          // If the user has set not to recieve the given type of alerts we put N/A rater than zero
                        this.userPrefixes[j].path_change_count = this.userPrefixes[j].opf_split[1] ? 0 : '#N/A'
                        this.userPrefixes[j].ownership_assertion_count = this.userPrefixes[j].opf_split[0] ? 0 : '#N/A'
                        this.userPrefixes[j].notification_str = ""
                    }
                } else {
                    for (var j = 0; j < this.orgPrefixes.length; j++) {
                        this.orgPrefixes[j].notification_count = 0
                        this.orgPrefixes[j].first_seen_count = this.orgPrefixes[j].opf_split[2] ? 0 : '#N/A'          // If the org has set not to recieve the given type of alerts we put N/A rater than zero
                        this.orgPrefixes[j].path_change_count = this.orgPrefixes[j].opf_split[1] ? 0 : '#N/A'
                        this.orgPrefixes[j].ownership_assertion_count = this.orgPrefixes[j].opf_split[0] ? 0 : '#N/A'   
                        this.orgPrefixes[j].notification_str = ""
                    }
                }
            }
        } catch (err) {
            console.log(err)
            if (usr == "user") {
                for (var j = 0; j < this.userPrefixes.length; j++) {
                    this.userPrefixes[j].notification_count = 0
                    this.userPrefixes[j].first_seen_count = this.userPrefixes[j].opf_split[2] ? 0 : '#N/A'          // If the user has set not to recieve the given type of alerts we put N/A rater than zero
                    this.userPrefixes[j].path_change_count = this.userPrefixes[j].opf_split[1] ? 0 : '#N/A'
                    this.userPrefixes[j].ownership_assertion_count = this.userPrefixes[j].opf_split[0] ? 0 : '#N/A'
                    this.userPrefixes[j].notification_str = ""
                }
            } else {
                for (var j = 0; j < this.orgPrefixes.length; j++) {
                    this.orgPrefixes[j].notification_count = 0
                    this.orgPrefixes[j].first_seen_count = this.orgPrefixes[j].opf_split[2] ? 0 : '#N/A'          // If the org has set not to recieve the given type of alerts we put N/A rater than zero
                    this.orgPrefixes[j].path_change_count = this.orgPrefixes[j].opf_split[1] ? 0 : '#N/A'
                    this.orgPrefixes[j].ownership_assertion_count = this.orgPrefixes[j].opf_split[0] ? 0 : '#N/A'   
                    this.orgPrefixes[j].notification_str = ""
                }
            }
        }

        var d = new Date();
        var day = ("0" + d.getUTCDate()).slice(-2);
        var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
        var year = d.getUTCFullYear()
        var dateFormatted = day + "/" + month + "/" + year
        var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2);
        this.updatedStr = "U: " + dateFormatted + " " + timeFormatted

        this.contLoading = true;
        this.$nextTick(() => {
        // Add the component back in
        this.contLoading = false;
        });

    },
    rawDownload: async function (epoch) {
        //Format required 2019-04-11 03:45:00
        var d = new Date (epoch * 1000);
        var day = ("0" + d.getUTCDate()).slice(-2);
        var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
        var year = d.getUTCFullYear()
        var dateFormatted = year + "-" + month + "-" + day;
        var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2) + ":00";
            
        var query = `query getURLFromS3 { 
                            getURLFromS3(date: "`+dateFormatted+`", time: "`+timeFormatted+`", time_range: 15) 
                                { url
                            } 
                        }`

        const returnURLs = await API.graphql(graphqlOperation(query));

        if (returnURLs.data.getURLFromS3 != false) {
            this.downloadLinkData = returnURLs.data.getURLFromS3[1];

            // This query downloads two types of data, CSP ingest and Route Views ingest. I've ommited 
            // CSP ingest as I seem to remember there being some contension about allowing all users to download this.
            // Its easy to do both but i chose to just do route Views - may need further discussion. 
        } else {
            this.downloadLinkData=false
        }
        
    },
    getUserNotifs: async function (value,hb) {
        this.currentHoursBack=hb;
        this.notificationType = 'user';
        this.whoIs = 'User';
        this.selectPrefix = value;
        this.show_popped = ""
        this.allow_popped = true
        this.getNotificationsForASN(value,hb)
    },
    getOrgNotifs: async function (value,hb) {
        this.currentHoursBack=hb;
        this.notificationType = 'org';
        this.whoIs = 'Org';
        this.selectPrefix = value;
        this.show_popped = ""
        this.allow_popped = true
        this.getNotificationsForASN(value,hb)
    },
    changeTop10Alerts: async function (value) {
        this.top10org = value;
    },
    tagDealtWith: async function (entry, tag) {
        entry.dealt_with = tag
        //console.log(entry)
        //console.log(tag)
        //console.log(this.current10Data.indexOf(entry))
        if ( tag == 1 ) {
            if ( entry.asn_of_interest == 'Restricted Prefix' ) {
                this.to_be_dealt.push({
                    prefix: entry.prefix,
                    origin_asn_new: entry.origin_asn_new,
                    origin_asn_old: entry.origin_asn_old,
                    time_5min: entry.time_5min,
                    asn_of_interest: 99999999999,
                    notified_organisation: entry.notified_organisation,
                    user: entry.user,
                    pos: this.data.indexOf(entry)
                })
            } else {
                this.to_be_dealt.push({
                    prefix: entry.prefix,
                    origin_asn_new: entry.origin_asn_new,
                    origin_asn_old: entry.origin_asn_old,
                    time_5min: entry.time_5min,
                    asn_of_interest: entry.asn_of_interest,
                    notified_organisation: entry.notified_organisation,
                    user: entry.user,
                    pos: this.data.indexOf(entry)
                })
            }
            
        } else {
            for ( var i = 0 ; i < this.to_be_dealt.length ; i++ ) {
                if ( this.to_be_dealt[i].prefix == entry.prefix &&
                    this.to_be_dealt[i].origin_asn_new == entry.origin_asn_new &&
                    this.to_be_dealt[i].origin_asn_old == entry.origin_asn_old &&
                    this.to_be_dealt[i].time_5min == entry.time_5min &&
                    this.to_be_dealt[i].asn_of_interest == entry.asn_of_interest &&
                    this.to_be_dealt[i].notified_organisation == entry.notified_organisation &&
                    this.to_be_dealt[i].user == entry.user
                ) {
                    this.to_be_dealt.splice( i , 1 )
                    i -= 1
                }
            }
        }
        if ( this.to_be_dealt.length > 0 ) {
            this.allow_dealt = true
        } else {
            this.allow_dealt = false
        }

    },
    updateDealtWithMany: async function (dealt_w) {
        // (`prefix`, origin_asn_new, origin_asn_old, time_5min, asn_of_interest, organisation_name, `user`)
        var sendings = []
        var to_go = []
        if ( this.show_popped != '' ) {
            dealt_w = 0
        }

        for ( var i = 0 ; i < this.to_be_dealt.length ; i++ ) {
            var entry = this.to_be_dealt[i]
            sendings.push(
                String.raw`(\"` + entry.prefix + String.raw`\",`
                + entry.origin_asn_new + `,` 
                + entry.origin_asn_old + `,` 
                + entry.time_5min + `,` 
                + entry.asn_of_interest + `,` 
                + String.raw`\"` + entry.notified_organisation + String.raw`\",\"` 
                + entry.user + String.raw`\")`
            )
            to_go.push(entry.pos)
        }
        var sendstr = sendings.join(",")
        try {
            var query = `query getUpdateDealtWithMany { 
                getUpdateDealtWithMany (
                    update_str: "` + sendstr + `", 
                    p_dealt_with: ` + dealt_w + `
                )
                {
                    ts
                }  
            }`;
//            console.log(query) 
            const updata = await API.graphql(graphqlOperation(query));
            //console.log(updata)
            var updated = updata.data.getUpdateDealtWithMany
            if ( parseInt(updated[0].ts) == 1 ) {
                console.log("updated successfully")
            }
        } catch (err) {
            console.log(err)
        }
        to_go.sort()
        //console.log(to_go)
        for ( var i = this.to_be_dealt.length - 1 ; i > -1 ; i-- ) {
            //console.log(to_go[i])
            this.data.splice(to_go[i], 1)
        }
        this.to_be_dealt = []
        this.allow_dealt = false
    },
    showPoppedAlerts: async function () {
        this.show_popped = ", p_dealt_with: 1 "
        this.allow_popped = false
        this.getNotificationsForASN(this.currentASN,this.hoursback)
    },
    showUnpoppedAlerts: async function () {
        this.show_popped = ""
        this.allow_popped = true
        this.getNotificationsForASN(this.currentASN,this.hoursback)
    },
    getAlertType: function (alert) {
        /* if (alert.asn_of_interest == 'Restricted Prefix') {
            return 'Restricted Prefix'
        } else */ 
        if (alert.origin_asn_old == '0' || alert.origin_asn_old == 0) {
            return 'First Seen Prefix'
        } else if (alert.origin_asn_new == alert.origin_asn_old) {
            return 'Path Change'
        } else {
            if (alert.non_direct_prefix == 'N/A' || !alert.non_direct_prefix) {
                return 'Ownership Assertion'
            } else {
                var nd_cidr = parseInt(alert.non_direct_prefix.split("/")[1])
                var cidr = parseInt(alert.prefix.split("/")[1])
                if (nd_cidr > cidr) {
                    return 'Super-ownership Assertion'
                } else {
                    return 'Sub-ownership Assertion'
                }

            }
        }
    },
    createBubbleDatasets: function() {

        var uniqueASNs
        var alerts
        var current_keys

        
        uniqueASNs = [this.currentASN]
        alerts = this.data
        current_keys = {}
        try {
            for (var i = 0 ; i < this.bubbleData.datasets.length ; i++ ) {
            current_keys[this.bubbleData.datasets[i].label] = this.bubbleData.datasets[i].backgroundColor
            }
        } catch {
            current_keys = {}
        }
        
        //console.log(uniqueASNs)
        //console.log(uniquePrefs)
        //console.log(alerts)
        //console.log(current_keys)
        
        var bubble_data = {
            datasets: []
        }

        for (var i = 0; i < uniqueASNs.length; i++ ) {
        if (!(Object.keys(current_keys).includes(uniqueASNs[i]))) {
            var datasetFull = {
            label: uniqueASNs[i],
            data: [],
            backgroundColor: "hsla(" + ~~(360 * Math.random()) + "," +"50%,"+"50%,1)"
            }
            bubble_data.datasets.push(datasetFull)
        } else {
            var datasetFull = {
            label: uniqueASNs[i],
            data: [],
            backgroundColor: current_keys[uniqueASNs[i]]
            }
            bubble_data.datasets.push(datasetFull)
        }
        }

        
    //    console.log("BUBBLE DATA")
     //   console.log(bubble_data)

        for (var i = 0 ; i < alerts.length ; i++ ) {
            
            //if (this.passCriteria(alerts[i])) {


            if (alerts[i].asn_of_interest == 'Restricted Prefix') {
                //console.log(alerts[i].controlled_prefix)
                var score_combo = alerts[i].hijack_score_mean
                if ( alerts[i].event_count > 50 ) {
                    var bubblesize = this.bubbleMaxSize
                } else {
                    var bubblesize = Math.round(alerts[i].event_count * (this.bubbleMaxSize - this.bubbleMinSize)/50) + this.bubbleMinSize
                }
                var dataset = {x: alerts[i].time_5min, y: score_combo, r: bubblesize, ev_count: alerts[i].event_count, full_alert: alerts[i]}
                for(var j = 0; j < bubble_data.datasets.length ; j++ ) {
                if (bubble_data.datasets[j].label == alerts[i].controlled_prefix) {
                    bubble_data.datasets[j].data.push(dataset)
                }  
                }

            } else {
                //console.log(alerts[i].asn_of_interest)
                var score_combo = alerts[i].hijack_score_mean
                if ( alerts[i].event_count > 50 ) {
                    var bubblesize = this.bubbleMaxSize
                } else {
                    var bubblesize = Math.round(alerts[i].event_count * (this.bubbleMaxSize - this.bubbleMinSize)/50) + this.bubbleMinSize
                }
                var dataset = {x: alerts[i].time_5min, y: score_combo, r: bubblesize, ev_count: alerts[i].event_count, full_alert: alerts[i]}
                for(var j = 0; j < bubble_data.datasets.length ; j++ ) {
                if (bubble_data.datasets[j].label == alerts[i].asn_of_interest) {
                    bubble_data.datasets[j].data.push(dataset)
                }  
                }
                
            }
            //}            
            
        }
        return bubble_data
    },
    chartHandle: async function (point, event) {
        //console.log(point)
        //console.log(event)
        if ( event.length > 0 ) {
            //console.log(event[0]._datasetIndex)
            //console.log(event[0]._index)
            //console.log(this.bubbleData.datasets[event[0]._datasetIndex].data[event[0]._index])
            this.bubble_alert = [this.bubbleData.datasets[event[0]._datasetIndex].data[event[0]._index].full_alert]
        }
    },
    useBubbleData: async function (usr) {
        if (usr == 'user') {
            var stored = this.showbubble
            this.showbubble = false
            this.bubble_alert = false
            this.bubble_type = 'user'
            this.bubbleHeaders[5].text[0] = this.username
            this.showbubble = stored
        } else {
            var stored = this.showbubble
            this.showbubble = false
            this.bubble_alert = false
            this.bubble_type = 'organisation'
            this.bubbleHeaders[5].text[0] = this.organisation
            this.showbubble = stored
        }
    },

    getNotificationsForASN: async function (value,hb) {
      var dd = Math.floor((new Date() / 1000 ) - 86400);
      dd = Math.floor((new Date() / 1000) - 3600 * hb);      
      if (this.notificationType == "user") {
        var p_user = this.$store.state.user.username
        if (!(Number.isInteger(value))) {
            this.title_str = this.username + " Alerts for " + value;
        } else {
            this.title_str = this.username + " Alerts for AS " + value;
        }
      } else {
        var p_user = "whole_organisation"
        if (!(Number.isInteger(value))) {
            this.title_str = this.organisation + " Alerts for " + value;
        } else {
            this.title_str = this.organisation + " Alerts for AS " + value;
        }
      }
      this.showContAlerts = false
      this.showAlerts = false
      this.showAlertsPanel = false
      this.showContAlertsPanel = false
      this.to_be_dealt = []
      this.allow_dealt = false

      if (!(Number.isInteger(value))) {
            this.showContAlerts = true
        } else {
            this.showAlerts = true
        }

      
      
   //   console.log(p_user)
  //    console.log(value)
      try {
        this.showevents = false;
        this.showtop10 = false
        this.currentASN = value;
        this.asnLoad = true;
        var query = `query getalerts { 
                        getNotificationsForOrgForASN( 
                          asn: "`+value+`",page_offset:`+ this.page_offset+`, 
                          page_rows:`+this.page_rows+`,
                          order_by:"`+this.order_by+`", 
                          start_time: ` + dd + `,
                          exclude_path_change: ` + !this.exclude_path_change + `,
                          exclude_first_seen: ` + !this.exclude_first_seen + `,
                          exclude_in_path: ` + !this.exclude_in_path + `,
                          exclude_own_assert: ` + !this.exclude_own_assert + `,
                          organisation: "` + this.$store.state.user.organisation + `",
                          p_user: "` + p_user + `" `
                          + this.show_popped + `
                          ) {
                            prefix
                            origin_asn_new
                            origin_asn_old
                            hijack_score_min
                            hijack_score_mean
                            hijack_score_mean
                            impact_score_min
                            impact_score_mean
                            impact_score_max
                            event_count
                            asn_of_interest
                            validation
                            countdown
                            email_count
                            organisation_name
                            notified_organisation
                            interval_start
                            asn_class
                            dealt_with
                            user
                            non_direct_prefix
                            controlled_prefix
                        } }`
    //    console.log(query)
        var alertData = null          
    //    console.log(alertData)
        alertData = await API.graphql(graphqlOperation(query));  
    //    console.log(alertData)
        
        var alert = alertData.data.getNotificationsForOrgForASN;
    //    console.log(alert)
        if (alert.length > 0 && alert[0].origin_asn_new != null) {
          this.alertperasn = [];
          var n;

            var urldata = window.location.origin + "/#/alertFromTop10/"

            for (n =0; n < alert.length; n=n+1) {
              if (alert[n].controlled_prefix=='Any') {
                  alert[n].controlled_prefix=''
              }
              if (alert[n].controlled_prefix) {
    //              console.log("CONTROLLED PREFIX")
                  alert[n].asn_of_interest = "Restricted Prefix";
              }
              if (alert[n].non_direct_prefix == 'null') {
                    alert[n].non_direct_prefix = 'N/A'
                }
              alert[n].dealt_with_t = false
              if (!this.asn_get_owner.includes(alert[n].asn_of_interest.toString())) {
                this.asn_get_owner.push(alert[n].asn_of_interest);
                }

                if (!this.asn_get_owner.includes(alert[n].origin_asn_old.toString())) {
                this.asn_get_owner.push(alert[n].origin_asn_old);
                }
                if (!this.asn_get_owner.includes(alert[n].origin_asn_new.toString())) {
                this.asn_get_owner.push(alert[n].origin_asn_new);
                }
              alert[n].alert_type = this.getAlertType(alert[n])
              alert[n].alert_url = urldata + alert[n].prefix.replace("/", "%2F") + "~" + alert[n].origin_asn_old + "~" + alert[n].origin_asn_new + "~" + alert[n].interval_start
              alert[n].dealt_with_t = false
              var epochTime = alert[n].interval_start;
              var dateTime = this.convertEpochtoTimeDate(epochTime);
              alert[n].time_5min = epochTime
              alert[n].interval_start  = dateTime
              // we set the asn of interest to the restricted prefix for display purposes
                if (alert[n].controlled_prefix && alert[n].asn_of_interest == 'Restricted Prefix') {
                    alert[n].asn_of_interest = alert[n].controlled_prefix
                }
              if (n == alert.length - 1) {
                    this.getASNOwners();
                }
            }
            
            
            this.alertperasn = alert
            this.data = this.alertperasn

            this.bubbleData = this.createBubbleDatasets()
            this.useBubbleData(this.org_user)

            this.id=this.id+1
            var count = this.alertNum + alert.length;
            this.alertNum = count
            
            var d = new Date();
            var day = ("0" + d.getUTCDate()).slice(-2);
            var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
            var year = d.getUTCFullYear()
            var dateFormatted = day + "/" + month + "/" + year
            var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2);

            if (!(Number.isInteger(value))) {
                this.updatedStrCont = "U: " + dateFormatted + " " + timeFormatted
                this.showContAlertsPanel = true
            } else {
                this.updatedStrASN = "U: " + dateFormatted + " " + timeFormatted
                this.showAlertsPanel = true
            }
            
            this.asnLoad = false;
            
            
        } else {
            this.data=[];
            this.id=this.id+1
            this.showevents = false
            this.bubbleData = this.createBubbleDatasets()
            this.useBubbleData(this.org_user)
            var d = new Date();
            var day = ("0" + d.getUTCDate()).slice(-2);
            var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
            var year = d.getUTCFullYear()
            var dateFormatted = day + "/" + month + "/" + year
            var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2);

            if (!(Number.isInteger(value))) {
                this.updatedStrCont = "U: " + dateFormatted + " " + timeFormatted
                this.showContAlertsPanel = true
            } else {
                this.updatedStrASN = "U: " + dateFormatted + " " + timeFormatted
                this.showAlertsPanel = true
            }
            this.asnLoad = false;
          
        }
      } catch (err) {
          console.log(err);
          this.asnLoad = false;
      }

    },
    getAnASNOwner: async function(asn) {
        if (asn == 0 || asn == 'N/A') {
            return "None";
        } else if (asn == 'Restricted Prefix') {
            return "Restricted Prefix"
        } else {
            try {
                var qry = `query getASNOwner { getASNOwner ( asn: "` +
                asn +
                `" ) {
                        organisation
                    }
                }`;
                //console.log(qry);
                const res = await API.graphql(graphqlOperation(qry));
                var ownData = res.data.getASNOwner;
                //console.log(ownData);
                if (ownData) {
                    if (ownData.length > 0) {
                    //console.log("owner: ");
                    //console.log(ownData[0].organisation);
                        if (ownData[0].organisation) {
                            return ownData[0].organisation;
                        } else {
                            return "Unknown";
                        }
                    } else {
                        return "Unknown";
                    }
                } else {
                    return "Unknown";
                }
            } catch (err) {
                console.log(err);
                return "Unknown";
            }
        }
    },
    getASNOwners: async function () {
        
    //    console.log("gettign asn owners")
        var nero = {}
        for ( var i = 0 ; i < this.asn_get_owner.length ; i++ ) {
            var keys = Object.keys(this.asn_own_dict)
            if (!(keys.includes((this.asn_get_owner[i]).toString()))) {
                nero[this.asn_get_owner[i]] = this.getAnASNOwner(this.asn_get_owner[i])
            }
        }
        for ( var i = 0 ; i < this.asn_get_owner.length ; i++ ) {
            
            
            //console.log("GETTING AN OWNER")
            if (!(keys.includes((this.asn_get_owner[i]).toString()))) {
                this.asn_own_dict[this.asn_get_owner[i]] = await nero[this.asn_get_owner[i]]
            }
            
            if ( i == this.asn_get_owner.length - 1 ) {
                //console.log("UPDATETICKER")
                this.asnLoad = true
                this.$nextTick(() => {
                    // Add the component back in
                    this.asnLoad = false;
                });
            }
        }
    },
    
    clickHandleAlert: async function (selectedAlertFromTable){

      var paramatersCombined = selectedAlertFromTable.prefix+"~"+selectedAlertFromTable.origin_asn_old+"~"+selectedAlertFromTable.origin_asn_new+"~"+ (selectedAlertFromTable.interval_start.epoch);
      let routeData = this.$router.resolve({name: 'Alert From Top 10', params: {prefix: paramatersCombined}});
                window.open(routeData.href, '_blank');
                //this.$router.push({ name: 'Alert From Top 10', 
                //                                params: {prefix: paramatersCombined}})
      //console.log("SELECTED ALERT");
      //console.log(selectedAlertFromTable);
      
    },
    convertEpochtoTimeDate: function (epochTime) {
                try {
                    var d_t = new Date( epochTime *1000);

                var date = d_t.toLocaleString().substr(0, 10);
                var time = d_t.toLocaleString().substr(11, 9);

                var dateTime  = {"date": date, "time": time, "epoch": epochTime}

                return dateTime
                }
                catch(err) {
                    console.log(err)
                }

            }
    },
    watch: {
        exclude_first_seen(n) {
            if (this.allowExcludeSwitches) {
                this.$store.commit("setAlertsExcFirst", n);
            }
            
    //        console.log("changing first seen")
    //        console.log(this.$store.state.alertsExcFirst)
        },
        exclude_path_change(n) {
            if (this.allowExcludeSwitches) {
                this.$store.commit("setAlertsExcPath", n);
            }
    //        console.log("changing path change")
     //       console.log(this.$store.state.alertsExcPath)
        },
        exclude_in_path(n) {
            if (this.allowExcludeSwitches) {
                this.$store.commit("setAlertsExcInPath", n);
            }
     //       console.log("changing in path")
     //       console.log(this.$store.state.alertsExcInPath)
        },
        exclude_own_assert(n) {
            if (this.allowExcludeSwitches) {
                this.$store.commit("setAlertsExcOwnAssert", n);
            }
     //       console.log("changing in path")
    //        console.log(this.$store.state.alertsExcInPath)
        },
        showOrgCont (n) {
            this.$store.commit("setShowSettings", { showOrgResSummary: n });
        },
        showUserCont (n) {
            this.$store.commit("setShowSettings", { showUserResSummary: n });
        },
        showbubble (n) {
            this.$store.commit("setShowSettings", { 'showBubble': n });
        },

    }
};
</script>

<style scoped>

    .content >>> .big-chip {
        width: 90px
    }

    table.v-table tbody td:first-child, 
    table.v-table tbody td:not(:first-child), 
    table.v-table tbody th:first-child, 
    table.v-table tbody th:not(:first-child), 
    table.v-table thead td:first-child, 
    table.v-table thead td:not(:first-child), 
    table.v-table thead th:first-child, 
    table.v-table thead th:not(:first-child) {
        padding: 0 5px
    }

    table.v-table tbody td, 
    table.v-table tbody th {
        height: 38px;
    }

    tbody tr:nth-of-type(even) {
      background-color: rgba(0, 0, 0, .05);
    }

    .v-table tr:hover:not(.v-table__expanded__content) {
        background-color: rgba(0, 0, 0, .4);
    }

    .special
    {
        cursor: pointer;
    }

</style>
